import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import classNames from 'classnames';
import noop from '../utils/noop';

function Swipe({
  axis = 'x',
  index = 0,
  enable = false,
  className = '',
  children,
  onChangeIndex = noop,
  onSwitching = noop,
  ...otherProps
}) {
  const swipeClasses = classNames('ws-swipe', className);

  return (
    <div className={swipeClasses}>
      <SwipeableViews
        axis={axis}
        index={index}
        animateTransitions={enable}
        onChangeIndex={onChangeIndex}
        onSwitching={onSwitching}
        enableMouseEvents={enable}
        disabled={!enable}
        {...otherProps}
      >
        {children}
      </SwipeableViews>
    </div>
  );
}

Swipe.propTypes = {
  axis: PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  index: PropTypes.number,
  enable: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onChangeIndex: PropTypes.func,
  onSwitching: PropTypes.func,
};

export default Swipe;
